// import { FiCalendar, FiMapPin } from "react-icons/fi";

// const events = [
//   { title: "International Trade Fair & Exhibition 2025", loc: "Mumbai, India", date: "March 18–22, 2025", type: "Exhibition", desc: "A premier platform for Indian exporters to showcase products, meet buyers, and explore new markets." },
//   { title: "India-Africa Business Forum", loc: "Nairobi, Kenya", date: "June 10–12, 2025", type: "Forum", desc: "Facilitating B2B meetings, investment pitches, and policy dialogues between Indian and African enterprises." },
//   { title: "BIMSTEC Trade & Investment Summit", loc: "Bangkok, Thailand", date: "August 05–07, 2025", type: "Summit", desc: "Strengthening regional supply chains, cross-border investments, and integrated trade corridors." },
//   { title: "Indo-American Business Roundtable", loc: "Washington D.C., USA", date: "September 22–24, 2025", type: "Roundtable", desc: "High-level discussions on technology collaboration, manufacturing partnerships, and market access." },
//   { title: "BRICS SME Forum & Expo", loc: "Moscow, Russia", date: "October 14–16, 2025", type: "Forum", desc: "Connecting small and medium enterprises across BRICS nations with access to capital and markets." },
//   { title: "Eurasia Economic Dialogue", loc: "Istanbul, Turkey", date: "November 03–05, 2025", type: "Dialogue", desc: "Exploring trade corridors, energy partnerships, and digital trade between India and Eurasian economies." },
// ];

// export default function Events() {
//   return (
//     <section id="events" className="scroll-mt-28 space-y-16">
//       <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#1a1a2e] to-[#2a2a40] px-8 py-14 md:px-16 md:py-20 shadow-2xl shadow-black/30">
//         <div className="absolute right-0 top-0 h-80 w-80 rounded-full bg-[#DA2128]/20 blur-3xl -mr-20 -mt-20" />
//         <div className="absolute left-10 bottom-10 h-48 w-48 rounded-full bg-[#DB6400]/20 blur-2xl" />
//         <div className="relative z-10 max-w-4xl">
//           <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-sm font-medium text-white backdrop-blur-md border border-white/10">
//             <FiCalendar className="h-4 w-4" /> Upcoming
//           </div>
//           <h2 className="font-['Cormorant_Garamond'] text-5xl md:text-7xl font-semibold text-white leading-[0.95] tracking-tight">
//             Events <span className="italic font-normal text-[#F59C00]">& Forums</span>
//           </h2>
//           <p className="mt-6 max-w-2xl text-lg text-white/85 leading-relaxed font-light">
//             Knowledge events, conferences, seminars, and business round-tables on bilateral and multilateral trade, global trade, foreign investment, and international economic affairs.
//           </p>
//         </div>
//       </div>

//       <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
//         {events.map((ev) => (
//           <a key={ev.title} href="#" className="group flex flex-col rounded-3xl bg-white border border-[#FEF7F4] p-8 shadow-xl shadow-black/[0.03] hover:-translate-y-2 hover:shadow-2xl hover:border-[#DA2128]/20 transition-all duration-300 relative overflow-hidden">
//             <div className="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-[#DA2128] via-[#DB6400] to-[#F59C00] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
//             <div className="mb-4 flex items-center gap-3">
//               <span className="rounded-full bg-[#DA2128]/10 text-[#DA2128] px-3 py-1 text-xs font-bold uppercase tracking-wide">{ev.type}</span>
//               <span className="text-xs text-[#9a9aab] font-medium">{ev.date}</span>
//             </div>
//             <h3 className="text-xl font-semibold text-[#1a1a2e] mb-3 font-['Outfit'] leading-snug group-hover:text-[#DA2128] transition-colors">{ev.title}</h3>
//             <p className="text-[#6a6a7a] leading-relaxed text-sm mb-6 flex-1">{ev.desc}</p>
//             <div className="flex items-center gap-4 text-xs text-[#9a9aab] font-medium pt-4 border-t border-[#FEF7F4]">
//               <span className="flex items-center gap-1.5"><FiMapPin className="h-3.5 w-3.5" /> {ev.loc}</span>
//               <span className="ml-auto text-[#DA2128] font-semibold flex items-center gap-1">Details <span>→</span></span>
//             </div>
//           </a>
//         ))}
//       </div>

//       {/* <div className="rounded-3xl bg-gradient-to-r from-[#FAF7F2] to-[#FEF7F4] p-10 md:p-14 border border-[#FEF7F4] flex flex-col md:flex-row gap-10 items-start md:items-center shadow-xl shadow-black/[0.02]">
//         <div className="flex-shrink-0 h-20 w-20 rounded-3xl bg-[#DA2128] text-white flex items-center justify-center text-3xl shadow-xl shadow-[#DA2128]/25">
//           <FiCalendar />
//         </div>
//         <div className="flex-1">
//           <h3 className="text-3xl font-semibold text-[#1a1a2e] mb-3 font-['Cormorant_Garamond'] tracking-tight">Host or Co-Host an Event</h3>
//           <p className="text-[#4a4a5a] leading-relaxed max-w-2xl">
//             ASSOCHAM invites members, partners, and international bodies to co-host conferences, business roundtables, and industry seminars. Collaborative events amplify reach, deepen engagement, and create lasting institutional ties.
//           </p>
//         </div>
//         <a href="#" className="inline-flex items-center gap-2 rounded-full bg-[#DA2128] text-white px-7 py-3.5 font-semibold text-sm shadow-xl shadow-[#DA2128]/25 hover:bg-[#DB2628] transition-colors whitespace-nowrap">Request Collaboration →</a>
//       </div> */}
//     </section>
//   );
// }






// new new code 





import { FiCalendar, FiMapPin, FiArrowUpRight, FiZap } from "react-icons/fi";
import { motion } from "framer-motion";

const events = [
  { title: "International Trade Fair & Exhibition 2025", loc: "Mumbai, India", date: "Mar 18–22, 2025", type: "Exhibition", desc: "A premier platform for Indian exporters to showcase products, meet buyers, and explore new markets." },
  { title: "India-Africa Business Forum", loc: "Nairobi, Kenya", date: "Jun 10–12, 2025", type: "Forum", desc: "Facilitating B2B meetings, investment pitches, and policy dialogues between Indian and African enterprises." },
  { title: "BIMSTEC Trade & Investment Summit", loc: "Bangkok, Thailand", date: "Aug 05–07, 2025", type: "Summit", desc: "Strengthening regional supply chains, cross-border investments, and integrated trade corridors." },
  { title: "Indo-American Business Roundtable", loc: "Washington D.C., USA", date: "Sep 22–24, 2025", type: "Roundtable", desc: "High-level discussions on technology collaboration, manufacturing partnerships, and market access." },
  { title: "BRICS SME Forum & Expo", loc: "Moscow, Russia", date: "Oct 14–16, 2025", type: "Forum", desc: "Connecting small and medium enterprises across BRICS nations with access to capital and markets." },
  { title: "Eurasia Economic Dialogue", loc: "Istanbul, Turkey", date: "Nov 03–05, 2025", type: "Dialogue", desc: "Exploring trade corridors, energy partnerships, and digital trade between India and Eurasian economies." },
];

export default function Events() {
  return (
    <section id="events" className="scroll-mt-8 py-6 ">
      {/* Compact Header matching your original typography */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 border-b border-gray-100 pb-6">
        <div>
          <div className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-[#DA2128]/10 px-3.5 py-1 text-xs font-semibold text-[#DA2128]">
            <FiZap className="h-3.5 w-3.5 animate-pulse" />
            <span>Upcoming Initiatives</span>
          </div>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-semibold text-[#1a1a2e] leading-tight tracking-tight">
            Events <span className="italic font-normal text-[#F59C00]">& Forums</span>
          </h2>
        </div>
        <p className="max-w-md text-sm text-[#6a6a7a] leading-relaxed font-light">
          Knowledge events, conferences, and roundtables on bilateral trade, foreign investment, and international affairs.
        </p>
      </div>

      {/* Grid with High Contrast White Cards & Smooth Entrance */}
      <motion.div 
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-50px" }}
        variants={{
          hidden: { opacity: 0 },
          show: { opacity: 1, transition: { staggerChildren: 0.06 } }
        }}
        className="grid gap-5 md:grid-cols-2 lg:grid-cols-3"
      >
        {events.map((ev, index) => (
          <motion.a
            key={index}
            href="#"
            variants={{
              hidden: { opacity: 0, y: 15 },
              show: { opacity: 1, y: 0, transition: { duration: 0.35 } }
            }}
            className="group relative flex flex-col justify-between rounded-2xl bg-white border border-[#FEF7F4] p-6 shadow-md shadow-black/[0.03] hover:-translate-y-1 hover:shadow-xl hover:border-[#DA2128]/30 transition-all duration-300 overflow-hidden"
          >
            {/* Top Border Animated Gradient Accent */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#DA2128] via-[#DB6400] to-[#F59C00] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />

            <div>
              {/* Type Badge & Date */}
              <div className="flex items-center justify-between gap-2 mb-3">
                <span className="rounded-full bg-[#DA2128]/10 text-[#DA2128] px-3 py-0.5 text-[11px] font-bold uppercase tracking-wider">
                  {ev.type}
                </span>
                <span className="flex items-center gap-1.5 text-xs text-[#9a9aab] font-medium">
                  <FiCalendar className="h-3.5 w-3.5 text-[#DB6400]" />
                  {ev.date}
                </span>
              </div>

              {/* Title with crisp dark color */}
              <h3 className="text-lg font-semibold text-[#1a1a2e] mb-2 font-['Outfit'] leading-snug group-hover:text-[#DA2128] transition-colors">
                {ev.title}
              </h3>

              {/* Description with clear contrast text */}
              <p className="text-[#6a6a7a] text-xs leading-relaxed line-clamp-2 mb-4">
                {ev.desc}
              </p>
            </div>

            {/* Location & Details Action Link */}
            <div className="pt-3 border-t border-gray-100 flex items-center justify-between text-xs font-medium text-[#9a9aab]">
              <span className="flex items-center gap-1.5 truncate max-w-[65%]">
                <FiMapPin className="h-3.5 w-3.5 text-[#DA2128] shrink-0" />
                <span className="truncate">{ev.loc}</span>
              </span>
              <span className="ml-auto text-[#DA2128] font-semibold flex items-center gap-1 group-hover:translate-x-1 transition-transform">
                Details <FiArrowUpRight className="h-4 w-4" />
              </span>
            </div>
          </motion.a>
        ))}
      </motion.div>
    </section>
  );
}